import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a62652e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("工量具批量借用")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("工量具批量报废")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("借用")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("报废")
const _hoisted_11 = {
  class: "msi-content",
  style: {"margin-top":"0","padding":"0"}
}
const _hoisted_12 = { class: "header" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除选中行")
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("确认")

import {
  WareToolStockPage,
  borrowWareToolStock,
  scrapWareToolHous
} from "@/service/main/gauge/manage";
import Pagination from "@/components/Pagination/index.vue";
import { exportExcel } from "@/utils/exportExcel";
import { ElMessage, ElMessageBox } from "element-plus";
import { ref } from "vue";
import { useStore } from "@/store";
import { formatUtcToData } from "@/utils/formate";

//store

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
// --------------------出库单列表-----------------------------------
//查询
const formModel = ref({
  Name: "",
  Code: "",
  Unit: "",
  PageNo: 1,
  PageSize: 10
});

//出库单列表数据
let tableData = ref([]);

//列表的数据条数
const totalItems = ref<number>(0);

//获取出库单列表
const getTabelData = () => {
  WareToolStockPage(formModel.value)
    .then((res) => {
      if (res.code == 200) {
        const { data } = res;
        const result = data;
        result.rows.map(
          (item: { hasChildren: boolean }) => (item.hasChildren = true)
        );
        tableData.value = result.rows;
        totalItems.value = result.totalRows;
      } else {
        ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`);
      }
    })
    .catch((err) => {
      console.log(err);
      ElMessage.error(JSON.stringify(err));
    });
};
getTabelData();

//重置搜索
const resetForm = () => {
  formModel.value = {
    Name: "",
    Code: "",
    Unit: "",
    PageNo: 1,
    PageSize: 10
  };
  getTabelData();
};
// -----------------删除、导出操作--------------------------
//选中的行
const checkRows = ref<{ orderNo: string }[]>([]);
// 选择
const handleSelectionChange = (val: any) => {
  checkRows.value = val;
};
//导出
const handExport = () => {
  let entozh = {
    id: "序号",
    code: "工量具编号",
    name: "工量具名称",
    specificationModel: "工量具规格",
    quantity: "数量",
    unit: "单位",
  };
  exportExcel(checkRows.value, entozh, "xlsx", "工量具管理列表");
};
//批量删除
const handle = (type: number) => {
  const handleArr: string[] = [];
  checkRows.value.forEach((item: any) => {
    item.createdTime = formatUtcToData(
      new Date().toString(),
      "YYYY-MM-DD hh:mm:ss"
    );
    item.createdUserName = store.state.login.userInfo.name;
    handleArr.push(item);
  });
  if (type == 1) {
    openDialog(3, handleArr);
  } else {
    openDialog(4, handleArr);
  }
};

//删除选中的物料详情
const delCheckedDetails = () => {
  ElMessageBox.confirm("是否确认删除？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      checkedDetails.value.forEach((item) => {
        const index = warehousOrderDetails.value.findIndex(
          (detail) => detail.code == item.code
        );
        warehousOrderDetails.value.splice(index, 1);
      });
    })
    .catch(() => ElMessage.info("已取消删除"));
};
// -------------------获取出库单下物料详情-----------------------------------

//入库单详情列表
const deltailList = ref<any[]>([]);

// ----------------新增、编辑-------------------------------
//窗口类型
const dialogType = ref("add");

const dialogVisible = ref(false);

//添加编辑表单ref
const orderId = ref(0);

//打开借用、报废窗口\link
const openDialog = (type: number, scope: any = {}) => {
  if (type == 1) {
    dialogType.value = "add";
    scope.createdTime = formatUtcToData(
      new Date().toString(),
      "YYYY-MM-DD hh:mm:ss"
    );
    scope.createdUserName = store.state.login.userInfo.name;
    warehousOrderDetails.value = [];
    warehousOrderDetails.value.push(scope);
  } else if (type == 2) {
    dialogType.value = "edit";
    scope.createdTime = formatUtcToData(
      new Date().toString(),
      "YYYY-MM-DD hh:mm:ss"
    );
    scope.createdUserName = store.state.login.userInfo.name;
    warehousOrderDetails.value = [];
    warehousOrderDetails.value.push(scope);
  } else if (type == 3) {
    warehousOrderDetails.value = [];
    dialogType.value = "add";
    warehousOrderDetails.value = scope;
  } else {
    warehousOrderDetails.value = [];
    dialogType.value = "edit";
    warehousOrderDetails.value = scope;
  }

  dialogVisible.value = true;
};

//物料详情的table ref
const detailRef = ref();

//关闭窗口
const closeDialog = () => {
  warehousOrderDetails.value = [];
  checkedDetails.value = [];
  deltailList.value = [];
  detailRef.value.clearSelection();
};

//添加编辑窗口物料列表
const warehousOrderDetails = ref<any[]>([]);

//物料详情列表选中的物料
const checkedDetails = ref<any[]>([]);

//物料详情列表中勾选事件
const detailsCheckChange = (val: any) => {
  checkedDetails.value = val;
};

//借用，报废
const confirm = () => {
  //借用
  if (dialogType.value == "add") {
    borrowWareToolStock(warehousOrderDetails.value)
      .then((res) => {
        if (res.code == 200) {
          ElMessage.success("借用成功");
          dialogVisible.value = false;
          getTabelData();
        } else {
          ElMessage.error(
            `借用失败${res?.code}:${JSON.stringify(res.message)}`
          );
        }
      })
      .catch((err) => {
        console.log(err);
        ElMessage.error(JSON.stringify(err));
      });
  } else {
    warehousOrderDetails.value.map((item) => {
      item.ordersId = orderId.value;
      return item;
    });
    scrapWareToolHous(warehousOrderDetails.value)
      .then((res) => {
        if (res.code == 200) {
          ElMessage.success("报废成功");
          dialogVisible.value = false;
          getTabelData();
        } else {
          ElMessage.error(
            `报废失败${res?.code}:${JSON.stringify(res.message)}`
          );
        }
      })
      .catch((err) => ElMessage.error(err));
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: formModel.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "工量具名称:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.Name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.Name) = $event)),
                        clearable: "",
                        placeholder: "请输入工量具名称"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "工量具编号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.Code,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.Code) = $event)),
                        clearable: "",
                        placeholder: "请输入工量具编号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "单位:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.Unit,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.Unit) = $event)),
                        clearable: "",
                        placeholder: "请输入单位"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { "label-width": "20px" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            icon: "el-icon-download",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handle(1)))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "info",
            icon: "el-icon-delete",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (handle(2)))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "el-icon-upload2",
            disabled: checkRows.value.length == 0,
            onClick: handExport
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        "row-key": "id",
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            width: "60",
            align: "center",
            type: "selection",
            "reserve-selection": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "60",
            type: "index"
          }),
          _createVNode(_component_el_table_column, {
            label: "工量具编号",
            width: "240",
            align: "center",
            prop: "code",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "工量具名称",
            prop: "name",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "工量具规格",
            prop: "specificationModel",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "数量",
            prop: "quantity",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "单位",
            prop: "unit",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "220px",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                icon: "el-icon-edit",
                onClick: ($event: any) => (openDialog(1, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                icon: "el-icon-delete",
                onClick: ($event: any) => (openDialog(2, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: formModel.value.PageNo,
        "onUpdate:page": _cache[5] || (_cache[5] = ($event: any) => ((formModel.value.PageNo) = $event)),
        limit: formModel.value.PageSize,
        "onUpdate:limit": _cache[6] || (_cache[6] = ($event: any) => ((formModel.value.PageSize) = $event)),
        onPagination: getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogType.value == 'add' ? '工量具借用' : '工量具报废',
      width: "60%",
      onClose: closeDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: warehousOrderDetails.value.length == 0,
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "info",
                icon: "el-icon-delete",
                plain: "",
                disabled: checkedDetails.value.length == 0,
                onClick: delCheckedDetails
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          (dialogType.value == 'add')
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 0,
                data: warehousOrderDetails.value,
                border: "",
                style: {"width":"100%"},
                "row-key": "id",
                ref_key: "detailRef",
                ref: detailRef,
                onSelectionChange: detailsCheckChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    width: "60",
                    "reserve-selection": "",
                    type: "selection"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "序号",
                    align: "center",
                    width: "60",
                    type: "index"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "工量具编号",
                    prop: "code",
                    align: "center",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "工量具名称",
                    prop: "name",
                    align: "center",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "工量具规格",
                    prop: "unit",
                    align: "center",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "借用数量",
                    align: "center",
                    width: "160"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input_number, {
                        modelValue: scope.row.quantity,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.quantity) = $event),
                        min: 1,
                        size: "small"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "借用人",
                    prop: "createdUserName",
                    align: "center",
                    "show-overflow-tooltip": ""
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        modelValue: scope.row.createdUserName,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.createdUserName) = $event),
                        min: 1,
                        size: "small"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "借用日期",
                    prop: "createdTime",
                    align: "center",
                    "show-overflow-tooltip": ""
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        modelValue: scope.row.createdTime,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.createdTime) = $event),
                        min: 1,
                        size: "small"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"]))
            : (_openBlock(), _createBlock(_component_el_table, {
                key: 1,
                data: warehousOrderDetails.value,
                border: "",
                style: {"width":"100%"},
                "row-key": "id",
                ref_key: "detailRef",
                ref: detailRef,
                onSelectionChange: detailsCheckChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    width: "60",
                    "reserve-selection": "",
                    type: "selection"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "序号",
                    align: "center",
                    width: "60",
                    type: "index"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "工量具编号",
                    prop: "code",
                    align: "center",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "工量具名称",
                    prop: "name",
                    align: "center",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "工量具规格",
                    prop: "specificationModel",
                    align: "center",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "单位",
                    prop: "unit",
                    align: "center",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "报废数量",
                    align: "center",
                    width: "160"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input_number, {
                        modelValue: scope.row.quantity,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.quantity) = $event),
                        min: 1,
                        size: "small"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "报废人",
                    prop: "createdUserName",
                    align: "center",
                    "show-overflow-tooltip": ""
                  })
                ]),
                _: 1
              }, 8, ["data"]))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})